import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import size from 'lodash/size';

import { btnLocationEnum } from 'utils/segment';
import Product from '../Product/Product';

import styles from './SimilarProducts.module.css';

const SimilarProducts = ({
  products,
  referrerProductId,
  hasSponsoredProductInCart,
  sponsoredThreshold,
  subtotal,
  gwpProducts,
  viewSize,
}) => {
  if (!size(products)) return null;
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Similar Products</h2>
      <div className={styles.productsContainer}>
        {map(products, (product, index) => (
          <Product
            key={product.id}
            positionOrder={index + 1}
            hasSponsoredProductInCart={hasSponsoredProductInCart}
            sponsoredThreshold={sponsoredThreshold}
            subtotal={subtotal}
            viewSize={viewSize}
            gwpProducts={gwpProducts}
            disableLazyLoading
            accordionInGrid={false}
            buttonLocation={btnLocationEnum.recommendedCard}
            referrerProductId={referrerProductId}
            style={{ marginBottom: 0 }}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...product}
          />
        ))}
      </div>
    </div>
  );
};

SimilarProducts.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape()),
  referrerProductId: PropTypes.number.isRequired,
  hasSponsoredProductInCart: PropTypes.bool.isRequired,
  sponsoredThreshold: PropTypes.number.isRequired,
  subtotal: PropTypes.number.isRequired,
  gwpProducts: PropTypes.arrayOf(PropTypes.shape()),
  viewSize: PropTypes.string.isRequired,
};

SimilarProducts.defaultProps = {
  products: [],
  gwpProducts: [],
};

export default SimilarProducts;
